import type {
  SupportAiSubscriptionInvoice,
  SupportAiUsageInvoice,
  SupportBaseInvoice,
  SupportVoiceSubscriptionInvoice,
  SupportVoiceUsageInvoice,
} from "@redotech/redo-billing-common/service-invoice";
import {
  supportAiSubscriptionInvoiceSchema,
  supportAiUsageInvoiceSchema,
  supportBaseInvoiceSchema,
  supportVoiceSubscriptionInvoiceSchema,
  supportVoiceUsageInvoiceSchema,
} from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export interface GetSupportInvoicesOutput {
  supportBaseInvoices: SupportBaseInvoice[];
  supportAiInvoices: (SupportAiSubscriptionInvoice | SupportAiUsageInvoice)[];
  supportVoiceInvoices: (
    | SupportVoiceSubscriptionInvoice
    | SupportVoiceUsageInvoice
  )[];
}

const getSupportInvoicesOutput_: z.ZodType<GetSupportInvoicesOutput> = z.object(
  {
    supportBaseInvoices: z.array(supportBaseInvoiceSchema),
    supportAiInvoices: z.array(
      z.union([
        supportAiSubscriptionInvoiceSchema,
        supportAiUsageInvoiceSchema,
      ]),
    ),
    supportVoiceInvoices: z.array(
      z.union([
        supportVoiceSubscriptionInvoiceSchema,
        supportVoiceUsageInvoiceSchema,
      ]),
    ),
  },
);

export const getSupportInvoices: {
  name: "getSupportInvoices";
  input: z.ZodObject<{ teamId: z.ZodType<string> }>;
  output: z.ZodType<GetSupportInvoicesOutput>;
} = {
  name: "getSupportInvoices" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: getSupportInvoicesOutput_,
};
